type OrderDisplayTarget = {
  id: number;
  supplier_order_number?: number | null;
};

export function getSupplierFacingOrderNumber(order: OrderDisplayTarget): number {
  return order.supplier_order_number ?? order.id;
}

export function getSupplierFacingOrderLabel(order: OrderDisplayTarget): string {
  return String(getSupplierFacingOrderNumber(order));
}
